import React, { useState, useEffect } from "react";
import {
    Modal,
    Input,
    Button,
    Space,
    Typography,
    message as antMessage,
    Tag,
} from "antd";
import { ReloadOutlined } from "@ant-design/icons";
import Table from "../../../../../core/common/dataTable/index"
import { useDispatch } from "react-redux";
import { all_routes } from "../../../../router/all_routes";
import api from "../../../../../core/axios/axiosInstance";
import { showToast } from "../../../../../core/data/redux/slices/ToastSlice";
import { Link, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { deleteCampaign, fetchCampaigns } from "../../../../../core/data/redux/slices/WabaCampaignSlice";
import { fetchTags } from "../../../../../core/data/redux/slices/TagSlice";
import { useDebounce } from "../../../../../core/hooks/useDebounce";
import TableSkeleton from "../../../../../core/common/TableSkeleton";

const { Text } = Typography;


const WabaCampaigns = () => {
    const route = all_routes;
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const [agents, setAgents] = useState([]);
    const [deleteCampaignModal, setDeleteCampaignModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);

    const [currentPage, setCurrentPage] = useState(1);
    const [pageLimit, setPageLimit] = useState(10);
    const [searchValue, setSearchValue] = useState("");
    const userProfile = useSelector((state) => state.profile);

    const role = userProfile?.role
    const isWhatsappConnected =
        userProfile?.accounts?.whatsapp?.isConnected;

    const debouncedSearch = useDebounce(searchValue, 500);


    const { campaigns, loading, count } = useSelector(
        (state) => state.wabaCampaign
    );



    useEffect(() => {
        const payload = {
            page: currentPage,
            limit: pageLimit,
            search: debouncedSearch,
        }
        dispatch(
            fetchCampaigns(payload)
        );
    }, [dispatch, currentPage, pageLimit, debouncedSearch]);




    const handleDeleteCampaign = async () => {
        if (!selectedCampaign) return;

        await dispatch(deleteCampaign(selectedCampaign.campaignId));
        setDeleteCampaignModal(false);
    };

    useEffect(() => {
        setCurrentPage(1);
    }, [searchValue]);


    const columns = [
        {
            title: "Campaign Name",
            dataIndex: "campaignName",
            sorter: (a, b) => a.campaignName.localeCompare(b.campaignName),
            render: (text, record) => (
                <div className="d-flex align-items-center">
                    <Link
                        className="customer-name"
                        to={
                            role === "user"
                                ? route.agentWabaCampaignDetails
                                : route.wabaCampaignDetails
                        }
                        state={{ record }}
                        style={{ color: "#2c5cc5", fontWeight: 700 }}
                    >
                        {text || "N/A"}
                    </Link>
                </div>
            ),
        },
        {
            title: "Template",
            dataIndex: "templateName",
            sorter: (a, b) => a.templateName.localeCompare(b.templateName),
        },
        // {
        //     title: "Total Messages",
        //     dataIndex: "totalMessages",
        // },

        {
            title: "Delivery Rate",
            dataIndex: "deliveryRate",
            render: (rate, record) => {
                const percentage = parseFloat(rate) || 0;
                const total = record.totalMessages || 0;

                const deliveredCount = Math.round((percentage / 100) * total);

                return (
                    <span>
                        {rate} ({deliveredCount}/{total})
                    </span>
                );
            },
            sorter: (a, b) =>
                parseFloat(a.deliveryRate) - parseFloat(b.deliveryRate),
        },

        {
            title: "Read Rate",
            dataIndex: "readRate",
            // render: (rate) => <span>{rate}</span>,
            render: (rate, record) => {
                const percentage = parseFloat(rate) || 0;
                const total = record.totalMessages || 0;

                const readCount = Math.round((percentage / 100) * total);

                return (
                    <span>
                        {rate} ({readCount}/{total})
                    </span>
                );
            },
            // sorter: (a, b) => a.readRate - b.readRate,
            sorter: (a, b) =>
                parseFloat(a.readRate) - parseFloat(b.readRate),
        },
        {
            title: "Status",
            dataIndex: "status",
            render: (status) => {
                switch (status) {
                    case "scheduled":
                        return <Tag color="blue">Scheduled</Tag>;

                    case "completed":
                        return <Tag color="green">Completed</Tag>;

                    default:
                        return <Tag>Unknown</Tag>;
                }
            },
        },

        {
            title: "Action",
            render: (_, record) => (
                <Space>
                    <Link
                        type="link"

                        // onClick={() => navigate(route.wabaCampaignDetails)}
                        to={
                            role === "user"
                                ? route.agentWabaCampaignDetails
                                : route.wabaCampaignDetails
                        }
                        state={{ record }}
                    >
                        <i className="ti ti-eye" />
                    </Link>
                    {role == "companyAdmin" && <Button
                        type="link"
                        danger
                        icon={<i className="ti ti-trash" />}
                        onClick={() => {
                            setSelectedCampaign(record)
                            setDeleteCampaignModal(true)
                        }
                        }
                    >

                    </Button>}
                </Space>
            ),
        },
    ];


    return (
        <>
            <div className="page-wrapper">
                <div className="content">

                    {!userProfile.isLoading && !isWhatsappConnected ? (

                        <div
                            style={{
                                height: "70vh",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                textAlign: "center",
                            }}
                        >
                            <h3>WhatsApp is not connected</h3>
                            <p style={{ color: "#888", marginBottom: 20 }}>
                                Please configure WhatsApp to start chatting.
                            </p>

                            <button
                                className="btn btn-primary"
                                onClick={() => {
                                    if (userProfile?.role === "companyAdmin") {
                                        navigate("/whatsapp/setting");
                                    }
                                }}
                                disabled={userProfile?.role !== "companyAdmin"}
                            >
                                {userProfile?.role === "companyAdmin"
                                    ? "Go to WhatsApp Settings"
                                    : "Contact your Company Admin"}
                            </button>
                        </div>

                    ) :

                        <div className="row">
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="row align-items-center">
                                            <div className="col-sm-12">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="page-header mb-0">
                                                        <div className="row align-items-center">
                                                            <h4 className="page-title mb-0">
                                                                Campaigns
                                                            </h4>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Input
                                                            placeholder="Search campaigns..."
                                                            value={searchValue}
                                                            onChange={(e) => {
                                                                setCurrentPage(1);
                                                                setSearchValue(e.target.value);
                                                            }}
                                                            style={{ width: 250, marginRight: 10 }}
                                                        />

                                                        <Button
                                                            icon={<ReloadOutlined />}
                                                            style={{ marginRight: 10 }}
                                                            loading={loading}
                                                            onClick={() => dispatch(fetchCampaigns({ page: currentPage, limit: pageLimit, search: debouncedSearch, forceRefresh: true }))}
                                                        >
                                                            Refresh
                                                        </Button>

                                                        <Button
                                                            type="primary"
                                                            onClick={() =>
                                                                navigate(
                                                                    role === "user"
                                                                        ? route.agentWabaAddCampaign
                                                                        : route.wabaAddCampaign
                                                                )
                                                            }
                                                        >
                                                            <i className="ti ti-plus me-2" />
                                                            Add Campaign
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-body">
                                        <div className="table-responsive">
                                            {loading && campaigns.length === 0 ? (
                                                <TableSkeleton
                                                    rows={8}
                                                    rowHeight={42}
                                                    columns={[
                                                        { width: 140, type: "text" },
                                                        { width: 110, type: "text" },
                                                        { width: 70,  type: "text" },
                                                        { width: 70,  type: "text" },
                                                        { width: 72,  type: "badge" },
                                                        { width: 60,  type: "action" },
                                                    ]}
                                                />
                                            ) : (
                                            <Table
                                                columns={columns}
                                                dataSource={campaigns}
                                                loading={false}
                                                rowKey="campaignId"
                                                pagination={{
                                                    current: currentPage,
                                                    pageSize: pageLimit,
                                                    total: count,
                                                    showSizeChanger: true,
                                                    showQuickJumper: false,
                                                    showTotal: (total, range) =>
                                                        `Showing ${range[0]}-${range[1]} of ${total} campaigns`,
                                                }}
                                                onPaginationChange={(page, pageSize) => {
                                                    setCurrentPage(page);
                                                    setPageLimit(pageSize);
                                                }}
                                                showRowSelection={false}
                                            />
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            {/* Delete Agent Modal */}
            <Modal
                title="Delete Campaign"
                centered
                open={deleteCampaignModal}
                onCancel={() => {
                    setDeleteCampaignModal(false);
                    setSelectedCampaign(null);
                }}
                footer={null}
                width={500}
            >
                <div style={{ padding: "20px 0" }}>
                    <Space direction="vertical" size="large" style={{ width: "100%" }}>
                        <div>
                            <Text style={{ fontSize: "16px" }}>
                                Are you sure you want to delete campaign?
                            </Text>
                            <br />
                            <br />
                            <Text type="danger" style={{ fontSize: "14px" }}>
                                This action cannot be undone. The campaign will
                                also be deleted.
                            </Text>
                        </div>

                        <Space style={{ width: "100%", justifyContent: "flex-end" }}>
                            <Button
                                size="large"
                                onClick={() => {
                                    setDeleteCampaignModal(false);

                                }}
                                disabled={isSubmitting}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="primary"
                                danger
                                size="large"
                                onClick={handleDeleteCampaign}
                                loading={isSubmitting}
                            >
                                Delete Campaign
                            </Button>
                        </Space>
                    </Space>
                </div>
            </Modal>
        </>
    );
};

export default WabaCampaigns;
